import { Colors, Text } from "@zapier/design-system";
import { useAtomValue } from "jotai";
import {
  areHandlesVisibleAtomFamily,
  hasVisibleAnnotationAtomFamily,
  isMultiSelectedAtomFamily,
  isOnlyNodeSelectedAtomFamily,
  PathNodeData,
  shouldShowStepIdsAtom,
} from "@zapier/canvas-state";
import { PATH_NODE_HEIGHT, PATH_NODE_WIDTH } from "@zapier/canvas-constants";

import { StepId } from "../../../StepId";
import { Handles } from "../../../Handles";
import { NodeHoverWrapper } from "../../../NodeHoverWrapper";

import styles from "./PathNode.module.css";

type Props = {
  data: PathNodeData;
  id: string;
};

const nodeStyles = {
  fill: Colors.BrandSky,
  strokeWidth: 0,
};

export function PathNode({ data, id }: Props) {
  const isOnlyNodeSelected = useAtomValue(isOnlyNodeSelectedAtomFamily(id));
  const isMultiSelected = useAtomValue(isMultiSelectedAtomFamily(id));
  const shouldShowStepIds = useAtomValue(shouldShowStepIdsAtom);
  const areHandlesVisible = useAtomValue(areHandlesVisibleAtomFamily(id));
  const hasVisibleAnnotation = useAtomValue(hasVisibleAnnotationAtomFamily(id));

  return (
    <NodeHoverWrapper>
      <svg
        width={PATH_NODE_WIDTH}
        height={PATH_NODE_HEIGHT}
        className={styles.pathNodeSvg}
      >
        {(isOnlyNodeSelected || isMultiSelected || hasVisibleAnnotation) && (
          <path
            d={`M-2,${PATH_NODE_HEIGHT / 2} L${PATH_NODE_WIDTH / 2},-2 L${
              PATH_NODE_WIDTH + 2
            },${PATH_NODE_HEIGHT / 2} L${PATH_NODE_WIDTH / 2},${
              PATH_NODE_HEIGHT + 2
            } z`}
            stroke={Colors.UiPrimary}
            strokeWidth={3}
            fill="none"
          />
        )}
        <path
          d={`M0,${PATH_NODE_HEIGHT / 2} L${
            PATH_NODE_WIDTH / 2
          },0 L${PATH_NODE_WIDTH},${PATH_NODE_HEIGHT / 2} L${
            PATH_NODE_WIDTH / 2
          },${PATH_NODE_HEIGHT} z`}
          {...nodeStyles}
        />
      </svg>
      <div className={styles.header}>
        <Text type="SectionHeader">?</Text>
      </div>
      <div className={styles.label}>
        <Text type="ParagraphHeader3">{data?.label}</Text>
      </div>
      <Handles nodeType="path" isVisible={areHandlesVisible} />
      {shouldShowStepIds && <StepId />}
    </NodeHoverWrapper>
  );
}
